import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/about')({
  component: About,
});

function About() {
  return (
    <main>
      <h1>About JND Bible</h1>
      <p className="muted">
        <em>Be still, and know.</em>
      </p>
      <p>
        JND Bible is a minimalist, ad-free, offline-first reader of the John Nelson Darby
        translation of the Holy Bible (1890). It is built for stillness, scripture retention, and
        growth in the knowledge of God. There are no advertisements, no tracking, no upsells.
      </p>

      <h2>Translation</h2>
      <p>
        The Darby Translation (1890) is in the <strong>public domain worldwide</strong>. The text in
        this app is sourced from the <code>scrollmapper/bible_databases</code> project, optionally
        upgraded to the eBible.org <code>engDBY</code> USFM source when available (which preserves
        added-word italics, paragraph and poetry markers, and red-letter markings for the words of
        Christ).
      </p>

      <h2>Storage &amp; privacy</h2>
      <p>
        Your favourites, notes, study sessions, and reading-plan progress live only in your
        browser&apos;s IndexedDB. Nothing is sent to a server unless you opt in to daily-verse
        notifications (in which case only your push endpoint and chosen tags are stored).
      </p>

      <h2>Version</h2>
      <p>v{import.meta.env.VITE_APP_VERSION ?? '0.1.0'}</p>

      <h2>Attribution</h2>
      <ul>
        <li>scrollmapper/bible_databases (BSD-style)</li>
        <li>eBible.org / Haiola (Michael Johnson)</li>
        <li>Literata typeface (TypeTogether / Google Fonts)</li>
        <li>Inter typeface (Rasmus Andersson)</li>
      </ul>

      <p className="faint" style={{ marginTop: '2rem' }}>
        Soli Deo gloria.
      </p>
    </main>
  );
}
